import BaseBotProvider from '@lskjs/bots-provider';

export class ClubhouseBotProvider extends BaseBotProvider {
  provider = 'clubhouse';
}

export default ClubhouseBotProvider;
